<a *ngIf="isSlings" class="sling-button" (click)="openSlingFormDialog()">
  <i class="pi pi-plus" [pTooltip]="'NEW_SLING' | translate" ></i>
</a>
<a *ngIf="isMovements" class="sling-button" (click)="openMovementPlanObjectivesFormDialog()">
  <i class="pi pi-plus"></i>
</a>
